$(document).ready(function(){
  var windowHeight = $(window).height();
  var windowWidth = $(window).width();

  // Init owl carousel
  $('.owl-carousel').owlCarousel({
      loop:true,
      items:1,
      dots:true,
      autoplay: true
  });

  //Resizing slider
  function sliderResize(){
    var myHeight = windowHeight-200;
    $(".slides,.owl-carousel").css("height",myHeight);
    setTimeout(function(){
      $(".bg-cover").backgroundCover();
    }, 100);
  }

  $(window).resize(function(){
    windowHeight = $(window).height();
    windowWidth = $(window).width();
    sliderResize();
  });

  sliderResize();

  $(document).ready(function(){
    $('.bxslider').bxSlider({
        auto: true
    });
  });

});
